import React from 'react';

export const text = (value) => (value == null ? '' : String(value));

export const formatPrintDate = (value, includeTime = false) => {
  if (!value) return '';
  const raw = typeof value?.format === 'function'
    ? value.format(includeTime ? 'YYYY-MM-DDTHH:mm:ss' : 'YYYY-MM-DD')
    : text(value);
  const dateOnly = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  const parsed = dateOnly
    ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
    : new Date(raw);
  if (Number.isNaN(parsed.getTime())) return raw;
  const date = new Intl.DateTimeFormat('en-US', {
    month: 'short', day: 'numeric', year: 'numeric',
  }).format(parsed);
  if (!includeTime || dateOnly) return date;
  const time = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric', minute: '2-digit',
  }).format(parsed);
  return `${date} at ${time}`;
};

export const formatSite = ({ address, city, state }) =>
  [text(address).trim(), [text(city).trim(), text(state).trim()].filter(Boolean).join(', ')]
    .filter(Boolean)
    .join(', ');

export const PrintHeader = ({ title, recordId, timestamp }) => (
  <header className="print-record-header">
    <div>
      <div className="print-record-kicker">Fleet Operations Record</div>
      <div className="print-record-brand">ManageLift</div>
    </div>
    <div className="print-record-heading">
      <div className="print-record-title">{title}</div>
      {(recordId || timestamp) && (
        <div className="print-record-identity">
          {recordId && <>Record {recordId}</>}
          {recordId && timestamp && ' · '}
          {timestamp && formatPrintDate(timestamp, true)}
        </div>
      )}
    </div>
  </header>
);

export const MetadataGrid = ({ cells }) => (
  <div className="print-record-metadata">
    {cells.map(({ label, value, wide }, index) => (
      <div className={`print-record-cell${wide ? ' print-record-cell-wide' : ''}`} key={`${label}-${index}`}>
        <div className="print-record-label">{label}</div>
        <div className="print-record-value">{text(value)}</div>
      </div>
    ))}
  </div>
);

export const SectionBar = ({ children }) => (
  <div className="print-record-section-bar">{children}</div>
);

export const PrintFooter = ({ title, recordId }) => (
  <footer className="print-record-footer">
    <span>ManageLift · Fleet Operations Record</span>
    <span>{title}{recordId ? ` · ${recordId}` : ''}</span>
  </footer>
);
